import _classPrivateFieldGet from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet.js";
import _classPrivateFieldSet from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classPrivateFieldSet.js";
var _client, _result, _queries, _options, _observers, _combinedResult, _lastCombine, _lastResult, _observerMatches, _trackResult, _combineResult, _findMatchingObservers, _onUpdate, _notify;
function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }
function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }
// src/queriesObserver.ts
import { notifyManager } from "./notifyManager.js";
import { QueryObserver } from "./queryObserver.js";
import { Subscribable } from "./subscribable.js";
import { replaceEqualDeep } from "./utils.js";
function difference(array1, array2) {
  const excludeSet = new Set(array2);
  return array1.filter(x => !excludeSet.has(x));
}
function replaceAt(array, index, value) {
  const copy = array.slice(0);
  copy[index] = value;
  return copy;
}
var QueriesObserver = (_client = /*#__PURE__*/new WeakMap(), _result = /*#__PURE__*/new WeakMap(), _queries = /*#__PURE__*/new WeakMap(), _options = /*#__PURE__*/new WeakMap(), _observers = /*#__PURE__*/new WeakMap(), _combinedResult = /*#__PURE__*/new WeakMap(), _lastCombine = /*#__PURE__*/new WeakMap(), _lastResult = /*#__PURE__*/new WeakMap(), _observerMatches = /*#__PURE__*/new WeakMap(), _trackResult = /*#__PURE__*/new WeakSet(), _combineResult = /*#__PURE__*/new WeakSet(), _findMatchingObservers = /*#__PURE__*/new WeakSet(), _onUpdate = /*#__PURE__*/new WeakSet(), _notify = /*#__PURE__*/new WeakSet(), class QueriesObserver extends Subscribable {
  constructor(client, _queries2, _options2) {
    super();
    _classPrivateMethodInitSpec(this, _notify);
    _classPrivateMethodInitSpec(this, _onUpdate);
    _classPrivateMethodInitSpec(this, _findMatchingObservers);
    _classPrivateMethodInitSpec(this, _combineResult);
    _classPrivateMethodInitSpec(this, _trackResult);
    _classPrivateFieldInitSpec(this, _client, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _result, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _queries, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _options, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _observers, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _combinedResult, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _lastCombine, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _lastResult, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _observerMatches, {
      writable: true,
      value: []
    });
    _classPrivateFieldSet(this, _client, client);
    _classPrivateFieldSet(this, _options, _options2);
    _classPrivateFieldSet(this, _queries, []);
    _classPrivateFieldSet(this, _observers, []);
    _classPrivateFieldSet(this, _result, []);
    this.setQueries(_queries2);
  }
  onSubscribe() {
    if (this.listeners.size === 1) {
      _classPrivateFieldGet(this, _observers).forEach(observer => {
        observer.subscribe(result => {
          _classPrivateMethodGet(this, _onUpdate, _onUpdate2).call(this, observer, result);
        });
      });
    }
  }
  onUnsubscribe() {
    if (!this.listeners.size) {
      this.destroy();
    }
  }
  destroy() {
    this.listeners = /* @__PURE__ */new Set();
    _classPrivateFieldGet(this, _observers).forEach(observer => {
      observer.destroy();
    });
  }
  setQueries(queries, options) {
    _classPrivateFieldSet(this, _queries, queries);
    _classPrivateFieldSet(this, _options, options);
    if (process.env.NODE_ENV !== "production") {
      const queryHashes = queries.map(query => _classPrivateFieldGet(this, _client).defaultQueryOptions(query).queryHash);
      if (new Set(queryHashes).size !== queryHashes.length) {
        console.warn("[QueriesObserver]: Duplicate Queries found. This might result in unexpected behavior.");
      }
    }
    notifyManager.batch(() => {
      const prevObservers = _classPrivateFieldGet(this, _observers);
      const newObserverMatches = _classPrivateMethodGet(this, _findMatchingObservers, _findMatchingObservers2).call(this, _classPrivateFieldGet(this, _queries));
      _classPrivateFieldSet(this, _observerMatches, newObserverMatches);
      newObserverMatches.forEach(match => match.observer.setOptions(match.defaultedQueryOptions));
      const newObservers = newObserverMatches.map(match => match.observer);
      const newResult = newObservers.map(observer => observer.getCurrentResult());
      const hasIndexChange = newObservers.some((observer, index) => observer !== prevObservers[index]);
      if (prevObservers.length === newObservers.length && !hasIndexChange) {
        return;
      }
      _classPrivateFieldSet(this, _observers, newObservers);
      _classPrivateFieldSet(this, _result, newResult);
      if (!this.hasListeners()) {
        return;
      }
      difference(prevObservers, newObservers).forEach(observer => {
        observer.destroy();
      });
      difference(newObservers, prevObservers).forEach(observer => {
        observer.subscribe(result => {
          _classPrivateMethodGet(this, _onUpdate, _onUpdate2).call(this, observer, result);
        });
      });
      _classPrivateMethodGet(this, _notify, _notify2).call(this);
    });
  }
  getCurrentResult() {
    return _classPrivateFieldGet(this, _result);
  }
  getQueries() {
    return _classPrivateFieldGet(this, _observers).map(observer => observer.getCurrentQuery());
  }
  getObservers() {
    return _classPrivateFieldGet(this, _observers);
  }
  getOptimisticResult(queries, combine) {
    const matches = _classPrivateMethodGet(this, _findMatchingObservers, _findMatchingObservers2).call(this, queries);
    const result = matches.map(match => match.observer.getOptimisticResult(match.defaultedQueryOptions));
    return [result, r => {
      return _classPrivateMethodGet(this, _combineResult, _combineResult2).call(this, r !== null && r !== void 0 ? r : result, combine);
    }, () => {
      return _classPrivateMethodGet(this, _trackResult, _trackResult2).call(this, result, matches);
    }];
  }
});
function _trackResult2(result, matches) {
  return matches.map((match, index) => {
    const observerResult = result[index];
    return !match.defaultedQueryOptions.notifyOnChangeProps ? match.observer.trackResult(observerResult, accessedProp => {
      matches.forEach(m => {
        m.observer.trackProp(accessedProp);
      });
    }) : observerResult;
  });
}
function _combineResult2(input, combine) {
  if (combine) {
    if (!_classPrivateFieldGet(this, _combinedResult) || _classPrivateFieldGet(this, _result) !== _classPrivateFieldGet(this, _lastResult) || combine !== _classPrivateFieldGet(this, _lastCombine)) {
      _classPrivateFieldSet(this, _lastCombine, combine);
      _classPrivateFieldSet(this, _lastResult, _classPrivateFieldGet(this, _result));
      _classPrivateFieldSet(this, _combinedResult, replaceEqualDeep(_classPrivateFieldGet(this, _combinedResult), combine(input)));
    }
    return _classPrivateFieldGet(this, _combinedResult);
  }
  return input;
}
function _findMatchingObservers2(queries) {
  const prevObserversMap = new Map(_classPrivateFieldGet(this, _observers).map(observer => [observer.options.queryHash, observer]));
  const observers = [];
  queries.forEach(options => {
    const defaultedOptions = _classPrivateFieldGet(this, _client).defaultQueryOptions(options);
    const match = prevObserversMap.get(defaultedOptions.queryHash);
    if (match) {
      observers.push({
        defaultedQueryOptions: defaultedOptions,
        observer: match
      });
    } else {
      observers.push({
        defaultedQueryOptions: defaultedOptions,
        observer: new QueryObserver(_classPrivateFieldGet(this, _client), defaultedOptions)
      });
    }
  });
  return observers;
}
function _onUpdate2(observer, result) {
  const index = _classPrivateFieldGet(this, _observers).indexOf(observer);
  if (index !== -1) {
    _classPrivateFieldSet(this, _result, replaceAt(_classPrivateFieldGet(this, _result), index, result));
    _classPrivateMethodGet(this, _notify, _notify2).call(this);
  }
}
function _notify2() {
  if (this.hasListeners()) {
    var _classPrivateFieldGet2;
    const previousResult = _classPrivateFieldGet(this, _combinedResult);
    const newTracked = _classPrivateMethodGet(this, _trackResult, _trackResult2).call(this, _classPrivateFieldGet(this, _result), _classPrivateFieldGet(this, _observerMatches));
    const newResult = _classPrivateMethodGet(this, _combineResult, _combineResult2).call(this, newTracked, (_classPrivateFieldGet2 = _classPrivateFieldGet(this, _options)) === null || _classPrivateFieldGet2 === void 0 ? void 0 : _classPrivateFieldGet2.combine);
    if (previousResult !== newResult) {
      notifyManager.batch(() => {
        this.listeners.forEach(listener => {
          listener(_classPrivateFieldGet(this, _result));
        });
      });
    }
  }
}
export { QueriesObserver };